import Request from 'redux/config/services/Request'
import { ProgramRecommenderStats } from './types'

export const getProgramRecommenderStats =
  async (): Promise<ProgramRecommenderStats> => {
    const response = await Request.get(`/hr/program_recommender/journey_stats/`)
    return response.data
  }
